import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function ScottianLifePage() {
  return <PublicPage slug="scottian-life" />;
}
